module.exports = __webpack_public_path__ + "static/media/PendingRelease-icons.StudiesDetail-Box.4f857aec.svg";